import React, { SVGProps } from 'react';
import styled from '@emotion/styled';
import { blue400, gray300 } from 'ts/studio/getTheme';
import { ShootProofIcon } from './icons';

const LoadingIconSvg = styled(ShootProofIcon)`
    @keyframes crop-top-left {
        0%,
        100% {
            fill: ${blue400};
        }
        25% {
            fill: ${gray300};
        }
        75% {
            fill: ${gray300};
        }
    }

    @keyframes crop-bottom-right {
        25%,
        75% {
            fill: ${gray300};
        }
        50% {
            fill: ${blue400};
        }
    }

    @keyframes crop-top-right {
        0%,
        50% {
            fill: ${gray300};
        }
        25% {
            fill: ${blue400};
        }
    }

    @keyframes crop-bottom-left {
        50%,
        100% {
            fill: ${gray300};
        }
        75% {
            fill: ${blue400};
        }
    }

    path {
        fill: ${gray300};

        &:nth-of-type(1) {
            animation: 1200ms infinite crop-top-left;
        }

        &:nth-of-type(2) {
            animation: 1200ms infinite crop-bottom-left;
        }

        &:nth-of-type(3) {
            animation: 1200ms infinite crop-bottom-right;
        }

        &:nth-of-type(4) {
            animation: 1200ms infinite crop-top-right;
        }
    }
`;

const LoadingIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
    return <LoadingIconSvg {...props} />;
};

export default LoadingIcon;
